export const ErrorReasonCodeToMessage: Record<number, string> = {
  400: 'Something went wrong. Please try again.',
  401: 'Your session expired. Please sign in again.',
  403: 'You don’t have access to this. Please contact support.',
  404: 'We couldn’t find the information. Try rephrasing your question.',
  409: 'There was a conflict processing your request. Please try again.',
  413: 'Your message is too long. Try breaking it into smaller parts.',
  422: 'We couldn’t understand that request. Please try again.',
  429: 'Too many requests. Please wait a moment and try again.',
  503: 'We’re temporarily down. Please try again in a few moments.',
  529: 'We’re experiencing high traffic. Please try again shortly.',
  504: 'The server did not respond in time. Please try again later.',
} as const
